import { render, staticRenderFns } from "./MaterialWizardSite.vue?vue&type=template&id=6c29a8be"
import script from "./MaterialWizardSite.vue?vue&type=script&lang=js"
export * from "./MaterialWizardSite.vue?vue&type=script&lang=js"
import style0 from "./MaterialWizardSite.vue?vue&type=style&index=0&id=6c29a8be&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports